import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=5813f8a6&scoped=true"
import script from "./BannerItem.vue?vue&type=script&lang=js"
export * from "./BannerItem.vue?vue&type=script&lang=js"
import style0 from "./BannerItem.vue?vue&type=style&index=0&id=5813f8a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5813f8a6",
  null
  
)

export default component.exports